/**
 * Stato dei pagamenti di un cantiere, derivato dalle sue fatture (StatoTab).
 * DBT-053 (decisione di Vale del 13/10): le fatture ANNULLATE non contano — una
 * fattura annullata non va pagata, quindi non può rendere «parziale» un
 * cantiere saldato. Le fatture arrivano dalla dashboard del cantiere con il
 * campo `status`.
 */
export function statoPagamentoDaFatture(fatture) {
  const vive = (fatture || []).filter((f) => f.status !== 'annullata');
  if (vive.length === 0) return 'nessuna';
  const pagate = vive.filter((f) => f.status === 'pagata').length;
  const scadute = vive.filter((f) => f.status === 'scaduta').length;
  if (pagate === vive.length) return 'saldato';
  if (scadute > 0) return 'in_ritardo';
  if (pagate > 0) return 'parziale';
  return 'da_pagare';
}
